import { Directive, ElementRef, HostListener, Inject, Input, OnDestroy, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Directive({
  selector: '[pgsTooltip]',
  exportAs: 'pgsTooltip'
})
export class PgsTooltipDirective implements OnDestroy {

  @Input('pgsTooltip') public text: string;
  @Input() public direction?: string;
  @Input() public delay?: number;

  private popup;
  private timer;
  private limitSetTimeout;

  constructor(
    private readonly ref: ElementRef,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.text = '';
    this.direction = 'up';
    this.delay = 30;
  }

  ngOnDestroy(): void {
    this.turnOff();
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    this.timer = setTimeout(() => {

      let x: number, y: number;

      switch (this.direction) {
        case 'up':
          x = this.ref.nativeElement.getBoundingClientRect().left - 5 + this.ref.nativeElement.offsetWidth / 2;
          y = this.ref.nativeElement.getBoundingClientRect().top + this.ref.nativeElement.offsetHeight - 43;
          break;
        case 'down':
          x = this.ref.nativeElement.getBoundingClientRect().left - 3 + this.ref.nativeElement.offsetWidth / 2;
          y = this.ref.nativeElement.getBoundingClientRect().bottom + this.ref.nativeElement.offsetHeight + 5;
          break;
        default: break;
      }

      this.createTooltipPopup(x, y);
    }, this.delay);
  }

  @HostListener('mouseleave') onMouseLeave(): void {
  this.turnOff();
  }

  private createTooltipPopup(x: number, y: number): void {
    this.popup = this.renderer.createElement('div');

    this.renderer.addClass(this.popup, 'tooltip-container');
    this.renderer.addClass(this.popup, `tooltip-container--${ this.direction }`);
    this.renderer.setStyle(this.popup, 'top', `${ y }px`);
    this.renderer.setStyle(this.popup, 'left', `${ x }px`);
    this.renderer.setStyle(this.popup, 'z-index', 11100);
    this.renderer.setProperty(this.popup, 'innerHTML', this.text);
    this.renderer.appendChild(this.document.body, this.popup);

    this.limitSetTimeout = setTimeout(() => this.turnOff(), 11700);
  }

  private turnOff(): void {
    this.timer && clearTimeout(this.timer);
    this.limitSetTimeout && clearTimeout(this.limitSetTimeout);
    this.popup && this.renderer.removeChild(this.document.body, this.popup);
  }
}
